import { createDraftSafeSelector as createSelector } from '@reduxjs/toolkit';
import { CryptoMapper } from '../mappers';
export const selectCertificates = createSelector([
    (state) => state.crypto.items,
    (_, inject) => inject(CryptoMapper),
], (items, format) => format.processCertificates(items));
export const selectCertificatesStatus = (state) => state.crypto.status;
export const selectCertificatesError = (state) => state.crypto.error;
